import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';

import { Settings } from '@folio/stripes/smart-components';
import { stripesShape } from '@folio/stripes/core';

import ChangePassword from './ChangePassword';
import UserPreferredAppsManager from './UserPreferredApps/UserPreferredAppsManager';

class MyProfile extends Component {
  static isLocalLogin(stripes) {
    return !stripes.okapi.ssoEnabled;
  }

  static propTypes = {
    actAs: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    showSettings: PropTypes.bool.isRequired,
    stripes: stripesShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.pages = [
      {
        route: 'password',
        label: <FormattedMessage id="ui-myprofile.settings.changePassword.label" />,
        component: ChangePassword,
        perm: 'ui-myprofile.settings.change-password',
      },
      // {
      //   route: 'locales',
      //   label: <FormattedMessage id="ui-myprofile.settings.userLocales.label" />,
      //   component: () => <div />,
      //   perm: 'ui-myprofile.settings.edit-locales',
      // },
      // {
      //   route: 'personal-picture',
      //   label: <FormattedMessage id="ui-myprofile.settings.userPersonalPicture.label" />,
      //   component: () => <div />,
      //   perm: 'ui-myprofile.settings.change-personal-picture',
      // },
      // {
      //   route: 'preferred-apps',
      //   label: <FormattedMessage id="ui-myprofile.settings.UserPreferredApps.label" />,
      //   component: UserPreferredAppsManager,
      //   // perm: 'ui-myprofile.settings.change-preferred-apps',
      // },
    ];
  }

  render() {
    if (!this.pages.length) return null;

    const { actAs, location, match, showSettings, stripes } = this.props;

    return (
      <Settings
        actAs={actAs}
        location={location}
        match={match}
        showSettings={showSettings}
        stripes={stripes}
        pages={this.pages}
        paneTitle={<FormattedMessage id="ui-myprofile.settings.index.paneTitle" />}
      />
    );
  }
}

export default MyProfile;
